<template>
  <el-form ref="form" label-width="12%" v-loading="loading" :model="catPropForm">
    <CatProp v-if="catPropSection" :props="catPropSection.component.props" />
  </el-form>
</template>

<script>
import { getForm, getItemPublishSchemaPropV2 } from '@/servers/prod/center/alibaba';
import { generateSections } from './utils/sections';
import { formatFormData, formatDataForm } from './utils/data';
import CatProp from './components/ComplexItem/CatProp.vue';
import { mapActions, mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';

// 批量修改类目的入口
export default {
  components: {
    CatProp,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    categoryIds: Array,
    value: {
      type: Array,
      default: [],
    },
  },
  provide() {
    return {
      alibabaFormVm: this,
    };
  },

  data() {
    return {
      loading: false,
      catPropSection: null,
      categoryId: '',
      catPropForm: {},
      initValue: [],
      emitUpdate: true,
      catPropSecondaryList: [],
      schema: {},
    };
  },
  computed: {
    ...mapGetters(['shops_defaultShopId', 'shops_getCategoryPropShopId']),
  },
  watch: {
    categoryIds: {
      handler(v) {
        if (v && v.length) {
          this.categoryId = v[v.length - 1];
          this.getUiData();
        } else {
          this.categoryId = '';
        }
      },
      immediate: true,
      deep: true,
    },
    catPropForm: {
      handler(v) {
        this.$emit('change', this.methods_getCatProps());
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(['updateCatePropShopIndex']),
    async getUiData() {
      this.loading = true;
      this.catPropSection = null;
      this.updateCatePropShopIndex('alibaba');
      const categoryIds = this.categoryIds;
      const res = await getForm({
        shopId: this.shops_defaultShopId('alibaba'),
        categoryId: categoryIds[categoryIds.length - 1],
      });
      this.loading = false;
      if (!res) {
        return false;
      }
      this.schema = res;
      this.formHandle();
    },
    methods_setCatProps(v) {
      this.formHandle(v);
    },
    formHandle(v) {
      // 动态表单
      if(!this.schema || !Object.keys(this.schema).length) return;
       // 动态表单
      const { formData, formSections } = generateSections(this.schema);
      const defaultForm = { ...formData, categoryIds: this.categoryIds };
      this.initValue = cloneDeep(v || this.value || [] )
      const form = formatDataForm({ fieldDescriptorList: v || this.value || [] }, formSections);
      this.catPropForm = { ...defaultForm, ...form };
      this.catPropSection = this._getCatPropSection(formSections.filter(item => item.children.length));

      const catPropChildren = this.catPropSection?.children;
      if (catPropChildren) {
        this.catPropSecondaryList = catPropChildren.filter(item => item?._oriRules?.childProp === 'true');
      }
      if (this.catPropSecondaryList.length) {
        this.$nextTick(async () => {
          await this.getSecondaryData(true);
        });
      }
      this.validate();
    },
    _getCatPropSection(formSections) {
      // 先找基础信息模块
      const baseSections = formSections.find(item => item.title === '基础信息');
      if (!baseSections) return null;

      const catPropSection = baseSections.children.find(item => item.name === 'catProp');
      if (!catPropSection) return null;

      return catPropSection;
    },
    async getSecondaryData(first) {
      if (!this.categoryId) return;
      const catPropField = this.getCatPropForm();
      let subCatPropData = {};
      catPropField.map(item => {
        subCatPropData[item.name] = {
          value: item.defaultValue,
          text: item.valueDisplayName,
        };
      });
      const res = await getItemPublishSchemaPropV2({
        shopId: this.shops_getCategoryPropShopId('alibaba'),
        categoryId: this.categoryId,
        dataBody: JSON.stringify({
          data: { catProp: subCatPropData },
        }),
      });
      this.updateSecondaryForm(res, first);
    },
    updateSecondaryForm(res, first) {
      // 找到新的类目属性的children
      const { formData, formSections } = generateSections(res);
      this.catPropSection = this._getCatPropSection(formSections.filter(item => item.children.length));
      if (first) {
        const defaultForm = { ...formData, categoryIds: this.categoryIds };
        const _form = formatDataForm({ fieldDescriptorList: this.initValue }, formSections);
        this.catPropForm = { ...defaultForm, ..._form };
      }
    },
    methods_getCatProps() {
      if (!this.catPropSection) return [];
      return [
        {
          label: '产品属性',
          name: 'catProp',
          type: 'COMPLEX',
          children: this.getCatPropForm(),
        },
      ];
    },
    getCatPropForm() {
      return formatFormData(cloneDeep(this.catPropForm), [this.catPropSection]);
    },
    validate() {
      return new Promise(resolve => {
        this.$refs.form &&
          this.$refs.form.validate(valid => {
            resolve(valid);
          });
      });
    },
  },
};
</script>

<style>
</style>